import React, { useEffect, useRef, useState } from 'react';
import SarasBadge from '../../../library/decor/badge/SarasBadge';
import {IconBell} from '../../../library/decor/SarasIcons';
import { startConnection, subscribe, unsubscribe } from '../../../helper/signalrHelper';
import LiveNotifyDialog from '../../../library/notifications/live/LiveNotifyDialog';
// import LiveNotifyToast from '../../../library/notifications/live/LiveNotifyToast';
import LiveNotifyStack from '../../../library/notifications/live/LiveNotifyStack';
import SarasTrans from '../../../library/notifications/SarasTrans';
import useFormApi from '../../../view/cmn/docAutomation/useFormApi';
import UserMessageList from './UserMessageList';
// import { useSnackbar } from 'notistack';

const normalizeNotificationItem = (item) => {
    return {
      id: item?.logId || `${Date.now()}_${Math.random().toString(36).substring(2, 8)}`,
      logId: item?.logId || 0,
      userId: item?.userId || 0,
      title: item?.title || 'Notification',
      message: item?.message || '',
      createdOn: item?.notificationSentOn || new Date().toISOString(),
      isLiveRead: item?.isLiveRead ?? false,
    };
};

const getMainViewDataV5 = (response) => {
    return response?.mainViewDataV5?.viewData || null;
};

const UserMessages=({deviceInfo})=>{
    const [liveMessages, setLiveMessages] = useState([]);
    const [liveCount, setLiveCount] = useState(0);
    const [menuMessages, setMenuMessages] = useState([]);
    
    //when a given notification is selected to be viewed
    const [selectedNotification, setSelectedNotification] = useState(null);
    
    //when a detailed response is received for a given notificaiton
    const [detailedMessage, setDetailedMessage] = useState(null);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [lastSeenOn, setLastSeenOn] = useState(null);
    const bellRef = useRef();
    const formApi = useFormApi();
    // const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
      // const openLiveNotification = (notification) => {
        // enqueueSnackbar('', {
        //   key: notification.id,
        //   autoHideDuration: 10000,
        //   anchorOrigin: { vertical: 'top', horizontal: 'right' },
        //   content: (key) => (
        //     <LiveNotifyToast
        //       notification={notification}
        //       onClose={() => closeSnackbar(key)}
        //       onOpen={() => {
        //         closeSnackbar(key);
        //         setSelectedNotification(notification);
        //       }}
        //     />
        //   )
        // });
      // };

      const onReceiveNotification = (payload) => {
        // console.log('notification live:', payload);
        const nextMessage = normalizeNotificationItem(payload);

        setLiveMessages((prevState) => [nextMessage, ...prevState]);
        setLiveCount((prevState) => prevState + 1);
        // openLiveNotification(nextMessage);
      };

      startConnection()
        .then(() => {
          subscribe('ReceiveNotification', onReceiveNotification);
        })
        .catch((error) => {
          console.log('Unable to start notification connection', error);
        });

      return () => {
        unsubscribe('ReceiveNotification', onReceiveNotification);
      };
    }, []);

    useEffect(() => {
      if (!selectedNotification) return;

      requestNotificationMessage(selectedNotification);
    }, [selectedNotification]);

    const openMessageDialog = (message) => {
      if (!message) return;

      setDetailedMessage(message);
      setIsDialogOpen(true);
    };

    const closeMessageDialog = () => {
      setIsDialogOpen(false);
      setDetailedMessage(null);
      setSelectedNotification(null);
    };

    const onNotificationMessageSuccess = (action, containerKey, rowKey, headerKey, response, targetLog) => {
      const notificationPayload = getMainViewDataV5(response);

      if (!notificationPayload) return;

      const dialogMessage = {
        title: notificationPayload?.title || 'Notification',
        message: notificationPayload?.message || '',
      };

      if (targetLog?.logId)
      {
        setMenuMessages((prevState) =>
          prevState.map((row) =>
            row.logId === targetLog.logId ? { ...row, isLiveRead: true } : row
          )
        );
      }

      if (targetLog?.id)
      {
        setLiveMessages((prevState) => prevState.filter((row) => row.id !== targetLog.id));
        setLiveCount((prevState) => Math.max(0, prevState - 1));
      }

      openMessageDialog(dialogMessage);
    };

    const requestNotificationMessage = (targetLog) => {
      if (!targetLog) return;

      if(!targetLog?.message){
        let customAction = {
          actionId: "get",
          actionName: "userData",
          actionParam: { 'content-type': 'notification-message', logId: targetLog.logId },
          containerKey: ""
        };

        formApi.runGenericAction(
          customAction,
          "userData",
          null,
          null,
          null,
          "",
          "",
          0,
          (action, containerKey, rowKey, headerKey, response) =>
            onNotificationMessageSuccess(action, containerKey, rowKey, headerKey, response, targetLog)
        );
      } else {
        //open the message dialog with the message already available in the targetLog
        const dialogMessage = {
          title: targetLog?.title || 'Notification',
          message: targetLog?.message || '',
        };

        openMessageDialog(dialogMessage);
      }
    };

    const onNotificationListSuccess = (action, containerKey, rowKey, headerKey, response) => {
      const notificationPayload = getMainViewDataV5(response);
      const notificationList = notificationPayload?.notificationList || [];
      const newMessageCount = notificationPayload?.newMessageCount ?? 0;

      setMenuMessages(notificationList.map(normalizeNotificationItem));
      setLastSeenOn(notificationPayload?.lastSeenOn || null);
      setLiveMessages([]);
      setLiveCount(newMessageCount > 0 ? newMessageCount : 0);
      setIsMenuOpen(true);
    };

    const requestNotificationList = () => {
      let customAction = {
        actionId: "get",
        actionName: "userData",
        actionParam: { 'content-type': 'notification-list' },
        containerKey: ""
      };

      formApi.runGenericAction(customAction, "userData", null, null, null, "", "", 0, onNotificationListSuccess);
    };

    const onCloseLiveToast = (messageId) => {
      setLiveMessages((prevState) => prevState.filter((row) => row.id !== messageId));
    };

    const onOpenLiveToast = (messageId) => {
      const selectedMessage = liveMessages.find((row) => row.id === messageId);

      if (!selectedMessage) return;

      setLiveMessages((prevState) => prevState.filter((row) => row.id !== messageId));
      setSelectedNotification(selectedMessage);
    };

    const onBellClick = () => {
      requestNotificationList();
    };

    const onMenuClose = () => {
      setIsMenuOpen(false);
    };

    const openNotificationMessage = (message) => {
      if (!message) return;

      setIsMenuOpen(false);
      setSelectedNotification(message);
    };

    const renderMenuTrigger = () => {
      return (
        <span ref={bellRef} className='uiAppIconWithLink' onClick={onBellClick}>
          <SarasBadge badge={liveCount} anchorOrigin={{vertical: 'top',horizontal: 'right'}} color="primary" style={{top: '2px',right: '0'}}>
            <IconBell className='uiAppIcon'/>
          </SarasBadge>
          {!deviceInfo?.activateMobileView && <span><SarasTrans value="Alerts" /></span>}
        </span>
      )
    }

    return(
      <>
        {renderMenuTrigger()}
        <UserMessageList
          anchorRef={bellRef}
          open={isMenuOpen}
          onClose={onMenuClose}
          messages={menuMessages}
          lastSeenOn={lastSeenOn}
          onOpenMessage={openNotificationMessage}
        />
        <LiveNotifyStack
          messages={liveMessages.slice(0, 1)}
          onCloseToast={onCloseLiveToast}
          onOpenMessage={onOpenLiveToast}
        />
        <LiveNotifyDialog
          open={isDialogOpen}
          notification={detailedMessage}
          onClose={closeMessageDialog}
        />
      </>
    )
}

export default UserMessages
